var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-autocomplete", {
        ref: "autocomplete",
        class: _vm.dense ? "grv-input-dense" : "grv-input",
        attrs: {
          "menu-props": {
            contentClass: "grv-menu",
            maxWidth: "991px",
            maxHeight: "50vh",
            closeOnContentClick: true
          },
          rules: _vm.rules,
          value: _vm.value,
          loading: _vm.loading,
          items: _vm.items,
          "item-value": "id",
          "item-text": "title",
          "search-input": _vm.search,
          readonly: _vm.readonly,
          "no-filter": "",
          clearable: "",
          flat: "",
          "hide-details": "",
          name: _vm.param.name
        },
        on: {
          "update:error": function($event) {
            _vm.errored = $event
          },
          "update:searchInput": function($event) {
            _vm.search = $event
          },
          "update:search-input": function($event) {
            _vm.search = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [_c("Label", { attrs: { param: _vm.param } })]
            },
            proxy: true
          },
          {
            key: "selection",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("span", { staticClass: "title mr-2" }, [
                  _vm._v("\n\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t"),
                  _c(
                    "span",
                    { staticClass: "background--text text--lighten-5 body-2" },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm._f("formatDateNoTime")(item.release_date)
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                ])
              ]
            }
          },
          {
            key: "item",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-list-tile",
                  {
                    key: item.id,
                    attrs: { avatar: "" },
                    on: {
                      click: function($event) {
                        return _vm.emitUpdate(item)
                      }
                    }
                  },
                  [
                    _c("v-list-tile-avatar", { attrs: { size: "auto" } }, [
                      item.poster_path
                        ? _c("img", {
                            attrs: {
                              width: "120",
                              height: "180",
                              loading: "lazy",
                              src: _vm.tmdb_img_url + item.poster_path,
                              alt: "Affiche de " + item.title
                            }
                          })
                        : _c("img", {
                            attrs: {
                              width: "120",
                              height: "180",
                              loading: "lazy",
                              src: require("@/assets/no_img.jpg"),
                              alt: "Pas d'affiche disponible"
                            }
                          })
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-list-tile-content",
                      [
                        _c("v-list-tile-title", { staticClass: "title" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(item.title) +
                              "\n\t\t\t\t\t\t"
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "tmdb-link ml-1",
                              attrs: {
                                href: _vm.getTmdbImgUrl(item),
                                target: "_blank"
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { "vertical-align": "middle" },
                                  attrs: { small: "" }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\topen_in_new\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-list-tile-sub-title",
                          [
                            _c(
                              "span",
                              {
                                class:
                                  item.pgm_type === "movie"
                                    ? "pgm-movie-chip"
                                    : "pgm-show-chip"
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(_vm._f("titleize")(item.pgm_type)) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            ),
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm._f("formatDateNoTime")(item.release_date)
                                ) +
                                "\n\t\t\t\t\t\t"
                            ),
                            _vm._l(item.genre_ids, function(genre_id) {
                              return _c(
                                "span",
                                { key: genre_id, staticClass: "genre-chip" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.genres[genre_id]) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("v-list-tile-sub-title", [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm._f("substring")(item.overview, 0, 670)
                              ) +
                              "\n\t\t\t\t\t"
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "append-item",
            fn: function() {
              return [
                _c("v-progress-linear", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasMorePages,
                      expression: "hasMorePages"
                    }
                  ],
                  staticClass: "ma-0",
                  attrs: { indeterminate: "", height: "3", color: "primary" }
                })
              ]
            },
            proxy: true
          },
          {
            key: "no-data",
            fn: function() {
              return [
                _c(
                  "v-list-tile",
                  [
                    _c(
                      "v-list-tile-content",
                      { staticStyle: { "align-self": "center" } },
                      [
                        _vm.loading
                          ? _c(
                              "v-list-tile-title",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("v-progress-circular", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    indeterminate: "",
                                    size: "16",
                                    width: "2",
                                    color: "primary"
                                  }
                                }),
                                _vm._v(
                                  "\n\t\t\t\t\t\tRecherche en cours...\n\t\t\t\t\t"
                                )
                              ],
                              1
                            )
                          : !_vm.search || _vm.search.length < 3
                          ? _c(
                              "v-list-tile-title",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\tTapez au moins 3 caractères pour lancer la recherche\n\t\t\t\t\t"
                                )
                              ]
                            )
                          : _c(
                              "v-list-tile-title",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\tAucun résultat trouvé\n\t\t\t\t\t"
                                )
                              ]
                            )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("Hint", { attrs: { param: _vm.param, errored: _vm.errored } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd4bd046", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd4bd046","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/fields/tmdb_id.vue
// module id = null
// module chunks = 